import React from 'react';
import { Button } from 'app/components';
import './style'

const Banner2 = () =>{
  return (
    <div className="banner2Container">
      <div className="banner2InnerContainer">
        <div className="banner2MainContainer">
          <div className="banner2ImgContainer">
            <img
              src="assets/images/badge2.svg"
              alt=""
              className="banner2Img"
            />
          </div>
          <div className="banner2Main">
            <h1 className="banner2Heading">List your event</h1>
            <p className="banner2Subtitle">
                Lowest fees and tailored features for your{' '}
              {window.innerWidth < 650 && <br />} events. Partner with us{' '}
              {window.innerWidth > 650 && <br />} and get your events listed
                on TakeMyTickets.
            </p>
          </div>
        </div>
        <Button
          className="btn_c"
          onClick={() => {
            window.open(
              '/landing',
              '_blank',
              'noopener,noreferrer',
            );
          }}
        >
            List your event
        </Button>
      </div>
    </div>
  );

}

export default Banner2;
